import { selectFromRouteDto } from '../../models';

export default selectFromRouteDto()
  // Many fields need the route.uuid
  .uuid
  .startDate
  .projectId
  .unpublishedChanges
  .isDispatched
  .isStarted
  .tags(tag => tag.uuid.name)
  .lastLocation(lastLocation => lastLocation.latitude.longitude.timestamp)
  .driver(driver => driver.deleted.user(user => user.id).invite(invite => invite.email.inviteLink.inviteStatusId).userInvite(userInvite => userInvite.inviteStatusId))
  .nextTimelineEvent(timelineEvent => timelineEvent.routeTimelineId.visitId.eventType.originalArrivalTime.expectedArrivalTime)
  .toString();
